// removed by extract-text-webpack-plugin
module.exports = {"root":"_1ETwFwf","clearSvg":"_-cFH9Lx"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/fields/TextField/ClearField/ClearField.less
 ** module id = 672
 ** module chunks = 0
 **/